import MyBreadcrumb from './breadcrumb';

/* istanbul ignore next */
MyBreadcrumb.install = function(Vue) {
  Vue.component(MyBreadcrumb.name, MyBreadcrumb);
};

export default MyBreadcrumb;


// WEBPACK FOOTER //
// ./src/components/common/breadcrumb/index.js